import { render, staticRenderFns } from "./invoiceDigitConfig.vue?vue&type=template&id=6b0dba3f&scoped=true"
import script from "./invoiceDigitConfig.vue?vue&type=script&lang=js"
export * from "./invoiceDigitConfig.vue?vue&type=script&lang=js"
import style0 from "./invoiceDigitConfig.vue?vue&type=style&index=0&id=6b0dba3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0dba3f",
  null
  
)

export default component.exports